function last(arr) {
    return arr[arr.length - 1];
}

export { last };
